import { render, staticRenderFns } from "./FacetFilters.vue?vue&type=template&id=2beb0275&"
import script from "./FacetFilters.vue?vue&type=script&lang=js&"
export * from "./FacetFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports